
import { granjaApi } from "../../api";
import { useProductosStore } from "../../store";
import Swal from "sweetalert2";






export const startProductoXID = async(id) => {
    try {
        const { data } = await granjaApi.get(`/producto/xid/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}



export const startProductosTodos = async(nombre) => {
    try {
        const params = new URLSearchParams();
        params.append('nombre',  nombre);
        const { data } = await granjaApi.get(`/producto/todos`, { params });
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}



export const startStockXProductos = async(id) => {
    try {
        const { data } = await granjaApi.get(`/producto/stocks/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}




export const startListadoProductos = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await granjaApi.get('/producto', { params });
        useProductosStore.setState({ totalProducto: data.total });
        return data.data;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const startSavingProducto = async(producto) => {
    try {
        if( producto.id ){
            await granjaApi.put(`/producto/${ producto.id }`, producto );
            Swal.fire('Exitoso', 'Producto Actualizado', 'success');
        }else {
            await granjaApi.post('/producto/new', producto);
            Swal.fire('Exitoso', 'Producto Creado', 'success');
            return true;
        }
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
} 

    



export const startDeleteProducto = async(id) => {
    try {
        const { data } = await granjaApi.delete(`/producto/${id}`);
        Swal.fire('Exitoso', 'Producto Eliminado', 'success');
        return data.data;
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
}